var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArchive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 28,
  "aria-hidden": "true",
  viewBox: "0 0 32 28"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11 12a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v1h-8v-1a1 1 0 0 0-1-1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M1 8h1v19a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V8h1a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1m29-6H2v4h28zM4 26V8h24v18z",
  clipRule: "evenodd"
})));
export default SvgArchive;